import OrderAPI from '@/services/order-api.service'
import widgetOptions from '../helpers/widget-options'
import store from '@/store'

const cartKey = `pab-cart-${widgetOptions.config.feed_id}`

export default {
  loadCart () {
    // get products in cart from local storage
    var storedCart = localStorage.getItem(cartKey)
    var cart = null
    if (storedCart) {
      try {
        cart = JSON.parse(localStorage.getItem(cartKey))
      } catch (e) {
        // parse failed, so we'll just dump the cart
        localStorage.removeItem(cartKey)
        return
      }
    }

    return this.sanitizeCart(cart)
  },

  /**
   * Remove items from cart that are no longer available
   * @param {*} cart cart object
   * @returns {*} cart object
   */
  sanitizeCart (cart) {
    if (!cart || !cart.order_items_attributes) {
      return cart
    }

    let products = cart.order_items_attributes
    cart.order_items_attributes = products.filter(
      p => store.getters['products/findProductByVariant'](p.product_id)
    )
    return cart
  },

  storeCart (cart) {
    localStorage.setItem(cartKey, JSON.stringify(cart))
    const cartUpdated = new Event('posabit-cart-updated')
    document.dispatchEvent(cartUpdated)
  },

  deleteStoredCart () {
    localStorage.removeItem(cartKey)
    const cartUpdated = new Event('posabit-cart-updated')
    document.dispatchEvent(cartUpdated)
  },

  placeOrder (order) {
    return OrderAPI.post({
      incoming_order: {
        order_type: order.order_type,
        source: order.source,
        first_name: order.first_name,
        last_name: order.last_name,
        email: order.email,
        telephone: order.telephone,
        address: order.address,
        city: order.city,
        state_abbrev: order.state_abbrev,
        zipcode: order.zipcode,
        reference_no: order.reference_no,
        requested_payment_method: order.requested_payment_method,
        order_items_attributes: order.order_items_attributes,
        payment_prepaid: order.payment_prepaid,
        payment_source: order.payment_source,
        payment_reference_id: order.payment_reference_id,
        payment_amount: order.payment_amount
      }
    })
  }
}
